import { defaultRouter, addRouter } from '@/router/index'
import lodash from 'lodash';
const routerData = {
  state: {
    routers: [],
    addRouters: []
  },
  mutations: {
    setRouters: (state, routers) => {
      state.addRouters = routers  // 保存动态路由用来addRouter
      console.log("路由",routers);
      state.routers = defaultRouter.concat(routers) // 所有有权限的路由表，用来生成菜单列表
    }
  },
  actions: { 
    newRoutes({ commit }, options) {
      if (!options.menus) {
        commit('setRouters', [])
        return;
      }
      //  通过递归路由表，删除掉没有权限的路由
      function eachSelect(routers, componentname) {
        var newrouter = lodash.cloneDeep(routers);
        newrouter.forEach((item) => {
          if (item && item.children && item.children.length) {
            eachSelect(routers[routers.findIndex(v => v.name === item.name)].children, componentname)
          }
          if (componentname.indexOf(item.name) == -1 && routers[routers.findIndex(v => v.name === item.name)].children.length == 0) {
            routers.splice(routers.findIndex(v => v.name === item.name), 1)
          }
        })
      }
      function getMenuCode(menu) {
        var menus = [];
        if (menu && menu.length > 0) {
          menu.forEach(element => {
            menus.push(element.MenuCode);
            if (element.Children && element.Children.length > 0) {
              menus = menus.concat(getMenuCode(element.Children));
            }
            else {
              return [];
            }
          });

        }
        return menus;
      }
      var menus = getMenuCode(options.menus[0].Menus);
      // 正式开发
      // console.log(menus);
      // eachSelect(addRouter, menus)
      commit('setRouters', addRouter)
    }
  }
}

export default routerData



// WEBPACK FOOTER //
// ./src/vuex/modules/routerData.js